export function countResortsWithAvailabilityFromResortList(resorts: ReadonlyArray<{ availableSuiteCount?: number }> | undefined | null): number | undefined {
  if (resorts == null) return undefined
  if (resorts.length === 0) return 0

  if (!resorts.some((r) => r.availableSuiteCount !== undefined)) return undefined

  return resorts.filter((r) => (r.availableSuiteCount ?? 0) > 0).length
}

type FiltersWithShowAvailableRow = {
  state?: {
    special?: {
      showAvailableOnly?: {
        count?: number
        value?: unknown
      }
    }
  }
}

export function mergeShowAvailableOnlyCount<T extends FiltersWithShowAvailableRow>(filters: T, count: number | undefined | null): T {
  const row = filters.state?.special?.showAvailableOnly
  if (!row) return filters

  const hasCount = typeof count === 'number' && !Number.isNaN(count)
  return {
    ...filters,
    state: {
      ...filters.state,
      special: {
        ...filters.state?.special,
        showAvailableOnly: {
          ...row,
          ...(hasCount ? { count: Number(count) } : { count: undefined }),
        },
      },
    },
  }
}
